import template from './employees_taking_leave_per_department_count_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EmployeesTakingLeavePerDepartmentCountHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeesTakingLeavePerDepartmentCountHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeesTakingLeavePerDepartmentCountHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeesTakingLeavePerDepartmentCountHelp',
	dialog_class: EmployeesTakingLeavePerDepartmentCountHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employees_taking_leave_per_department_count_help',
	provider: 'ps'
};
